<template>
  <div class="student-add">
    <div class="tuolele-main-box">
      <el-row type="flex" justify="end" class="tuolele-main-search">
        <el-button type="primary" @click="excelUpload">Excel模板下载</el-button>
        <el-upload
          class="upload-demo"
          action="string"
          :with-credentials="true"
          :show-file-list="false"
          :headers="{ 'Content-Type': 'multipart/form-data' }"
          :http-request="uploadFile"
          accept=".xls"
          name="file"
        >
          <el-button slot="trigger" type="success">导入Excel表</el-button>
        </el-upload>
        <el-tooltip placement="left">
          <div slot="content">
            <p class="el-tooltip__popper-text">
              操作提示：
              <br>导入的Excel请使用Excel模板哦，否则会导入失败！
            </p>
          </div>
          <i class="el-icon-question" />
        </el-tooltip>
      </el-row>
      <el-form ref="form" :model="studentInfo" label-width="120px">
        <el-form-item label="归属校区" required>
          <el-radio-group v-model="studentInfo.shop_id">
            <el-radio
              v-for="(item, index) in shopList"
              :key="index"
              :label="item.id"
              :value="item.id"
            >{{ item.name }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="家长手机号" required>
          <el-input
            v-model="studentInfo.mobile"
            clearable
            placeholder="请输入家长手机号"
            @input="checkMobile"
          />
          <div v-if="leadsInfo.children_names" class="student-other-info">
            <p>此手机号已在系统中注册过！</p>
            <p>已注册信息：</p>
            <p>家长姓名：{{ leadsInfo.parent_name }}</p>
            <p>孩子姓名：{{ leadsInfo.children_names }}</p>
          </div>
        </el-form-item>
        <el-form-item label="来源渠道" required>
          <el-radio-group v-model="studentInfo.channel_id">
            <el-radio
              v-for="(item, index) in channelList"
              :key="index"
              :label="item.id"
              :value="item.id"
              @change="changeChannelList(index)"
            >{{ item.name }}</el-radio>
          </el-radio-group>
          <div v-if="sourceTypeList.length != 0" class="student-add-type">
            <el-radio-group v-model="studentInfo.channel_sub_id">
              <el-radio
                v-for="(item, index) in sourceTypeList"
                :key="index"
                :label="item.id"
                :value="item.id"
              >{{ item.name }}</el-radio>
            </el-radio-group>
          </div>
        </el-form-item>
        <el-form-item label="学生姓名">
          <el-input
            v-model="studentInfo.child_name"
            clearable
            placeholder="请输入学生姓名"
          />
        </el-form-item>
        <el-form-item label="家长姓名">
          <el-input
            v-model="studentInfo.parent_name"
            clearable
            placeholder="请输入家长姓名"
          />
        </el-form-item>
        <el-form-item label="备注">
          <el-input
            v-model="studentInfo.remark"
            type="textarea"
            resize="none"
            :autosize="{ minRows: 4 }"
            placeholder="备注"
          />
        </el-form-item>
        <el-form-item class="form-buttom">
          <el-button
            type="primary"
            class="el-button-confirm"
            @click="createLeads"
          >保存</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-dialog title="导入失败Leads" :visible.sync="dialogVisible" width="40%">
      <el-table :data="errorList">
        <el-table-column
          property="mobile"
          label="手机号码"
          width="120px"
        />
        <el-table-column
          property="error_msg"
          label="失败信息"
        />
      </el-table>
    </el-dialog>
  </div>
</template>
<script>
import jquery from 'jquery'
export default {
  name: 'StudentAdd',
  components: {},
  data() {
    return {
      type: 'add',
      shopList: [],
      channelList: [],
      sourceTypeList: [],
      sourceType: [],
      studentInfo: {},
      leadsInfo: {},
      errorList: [],
      dialogVisible: false
    }
  },
  mounted() {
    this.getMyShopList()
    this.getChannleList()
  },
  methods: {
    excelUpload() {
      window.location.href =
        'http://late-care.tuolele.cn/Leads%E4%B8%8A%E4%BC%A0%E6%A8%A1%E6%9D%BF.xls'
    },
    uploadFile(params) {
      const file = params.file
      const self = this
      const formData = new FormData()
      formData.append('file', file)
      jquery.ajax({
        // url: 'http://172.16.10.234:8889/cms.php/Excelupload/appendLeads',
        url: 'http://third.tuolele.cn/cms.php/Excelupload/appendLeads',
        type: 'post',
        data: formData,
        contentType: false,
        processData: false,
        xhrFields: {
          withCredentials: true
        },
        crossDomain: true,
        success: function(res) {
          if (res.code == 200) {
            self.$message({
              type: 'success',
              message: '导入成功！'
            })
          } else if (res.code == 540 && res.data) {
            self.errorList = res.data
            self.dialogVisible = true
          } else if (res.code == 550) {
            self.$message({
              type: 'info',
              message: res.desc
            })
          }
        }
      })
    },
    getMyShopList() {
      this.$http.getMyShopList().then(res => {
        this.shopList = res.data
      })
    },
    checkMobile() {
      if (this.studentInfo.mobile.length == 11) {
        this.$http
          .checkMobile({ mobile: this.studentInfo.mobile })
          .then(res => {
            this.leadsInfo = res.data
            this.studentInfo.member_id = res.data.member_id
          })
      }
    },
    getChannleList() {
      this.$http.getChannleList().then(res => {
        this.channelList = res.data.splice(1)
        this.sourceType = this.channelList.map(item => {
          return item._child
        })
      })
    },
    changeChannelList(val) {
      this.sourceTypeList = this.sourceType[val]
      if (this.sourceTypeList.length == 0) {
        this.studentInfo.channel_sub_id = ''
      }
    },
    createLeads() {
      if (!this.studentInfo.shop_id) {
        this.$message({
          type: 'info',
          message: '请选择归属学校'
        })
        return
      }
      if (!this.studentInfo.mobile) {
        this.$message({
          type: 'info',
          message: '请填写家长手机号码'
        })
        return
      }
      if (!this.studentInfo.channel_id) {
        this.$message({
          type: 'info',
          message: '请选择来源渠道'
        })
        return
      }
      if (this.sourceTypeList.length != 0 && !this.studentInfo.channel_sub_id) {
        this.$message({
          type: 'info',
          message: '请选择渠道类型'
        })
        return
      }
      this.$http.createLeads(this.studentInfo).then(res => {
        if (res.code == 200) {
          this.$message({
            type: 'success',
            message: '新增Leads成功'
          })
          this.leadsInfo = {}
          this.studentInfo = {}
        }
      })
    }
  }
}
</script>
<style lang="scss">
.student-add {
  .upload-demo {
    display: inline-block;
    margin-left: 10px;
  }
  .tuolele-main-search {
    padding-bottom: 20px;
    margin-bottom: 20px;
  }
  .el-radio-group {
    width: 99%;
    padding-top: 10px;
  }
  .el-radio {
    margin: 0 40px 30px 0;
  }
  .el-input {
    width: 180px;
  }
  .el-textarea {
    width: 690px;
  }
  .student-add-type {
    width: 800px;
    margin-left: 8px;
    background-color: #fafafa;
    border-radius: 6px;
    border: solid 1px #ebebeb;
    .el-radio {
      margin: 0 18px 10px;
    }
    .el-radio:last-child {
      margin-right: 0;
    }
  }
  .student-other-info {
    width: 380px;
    padding: 8px 10px;
    margin-top: 15px;
    margin-left: 8px;
    line-height: 25px !important;
    font-size: 14px;
    color: #333333;
    background-color: #fafafa;
    border-radius: 6px;
  }
  .el-dialog {
    .el-dialog__title {
      color: #4c84ff;
    }
    .el-upload {
      text-align: left;
    }
    .select-file {
      display: inline-block;
      width: 110px;
      height: 40px;
      text-align: center;
      line-height: 40px;
      color: #4c84ff;
      margin: 0 0 10px 20px;
      border-radius: 6px;
      background: #fff !important;
      border: solid 1px #4c84ff !important;
    }
    p {
      color: #ff6c4c;
      margin-left: 80px;
    }
    .confirm {
      width: 110px;
      height: 40px;
      margin: 50px 0 0 80px;
      background-color: #4c84ff;
      border-radius: 6px;
    }
  }
  .el-dialog {
    .el-table tr th {
      background: #fff;
      color: #333;
      font-size: 16px;
      font-weight: bold;
      height: 40px;
      text-align: left;
    }
    .el-table td,
    .el-table th {
      text-align: left;
      border: none;
    }
  }
}
</style>
